import React, { useState, useEffect } from "react";
import { useGlobal } from "reactn";
import styles from "./LayerSelectorItem.module.scss";
import ToggleSwitch from "../../../atoms/toggleSwitch/ToggleSwitch";
import ExpandableContainer from "../../../atoms/expandableContainer/ExpandableContainer";
import Slider from "../../../atoms/slider/Slider";
import SliderMinMax from "../../../atoms/sliderMinMax/SliderMinMax";
import { CSVLink } from "react-csv";

const LayerSelectorItem = (props) => {
  const {
    name,
    desc,
    handleClick,
    rangeChange,
    opacityChange,
    dataType,
    selectedState,
    layerColour,
    itemCount
  } = props;

  const [activeState, setActiveState] = useState(false);
  const [openState, setOpenState] = useState(false);
  const [isLoading, setIsLoading] = useGlobal("isLoading");
  const [clickName, setClickName] = useGlobal("clickName")
  const [autoClick, setAutoClick] = useState(false)
  const [opaSliderValue, setopaSlicerValue] = useState()
  const [buildCSV] = useGlobal('buildCSV')
  const [childrenCovered, ] = useGlobal("childrenCovered")
  const [showDataLookup,] = useGlobal('showDataLookup')

  // eslint-disable-next-line
  const [localLoading, setLocalLoading] = useState(false);
  const dataLookup = [...showDataLookup]

  useEffect(() => {
    setActiveState(false)
    setOpenState(false)
    setAutoClick(function getInitialState() {
      let isPrimary = false
      if (name === 'PrimarySchools') {
        isPrimary = true
      }
      return isPrimary;
    })
  }, [selectedState, name]);

  useEffect(() => {
    const result = dataLookup.find(function( obj ) { return obj.id === name; })
    const opacityVal = (result) ? result.opacity : result
    setopaSlicerValue(opacityVal)
    // eslint-disable-next-line
  }, [showDataLookup])

  const LayerStyle = {
    borderColor: layerColour,
  };

  const toggleClick = (event) => {
    const clickName = event.currentTarget.getAttribute('data-id')
    setClickName(clickName)
    setIsLoading(true)
    setLocalLoading(true)
    setActiveState(!activeState)
    setOpenState(!openState)
    handleClick(event)
  };

  const sliderChange = (value) => {
    const sliderVal = {"name" : name, "values" : value}

    opacityChange(sliderVal)
  };

  const handleRangeChange = (values) => {
    rangeChange(values)
  };

  const toggleState = (isLoading && (clickName === name)) ? true : false 

  return (
    <div className={styles.outer} style={activeState ? LayerStyle : null}>
      <div className={styles.layerItem}>
        <div className={styles.layerDesc}>{desc}</div>
        {/* Potentially add extra information box here. Tooltip to display more information about the layer */}
        <div className={styles.toggleContainer}>
          <ToggleSwitch
            onClick={toggleClick}
            spinner={toggleState}
            id={name}
            dataType={dataType}
            activeState={activeState}
            autoClick={autoClick}
          />
        </div>
      </div>
      <div>
        <ExpandableContainer id={"test"} isOpen={openState}>
          <Slider
            disabled={activeState}
            onChange={sliderChange}
            id={name}
            dataType={dataType}
            initialValue={opaSliderValue}
          />
          {name.includes("Proposed") &&
            <>
            <hr></hr>
            <h5>Filtering Data</h5>
            <SliderMinMax
              disabled={activeState}
              onChange={handleRangeChange}
              id={name}
              dataType={dataType}
              itemCount={itemCount}
            />
            <p className={styles.layerDesc}> Total Number of Children covered: {parseFloat(childrenCovered).toFixed(2)}</p>
            
            
          <CSVLink data={buildCSV} filename={`${selectedState}-data.csv`} className={styles.linkButton}>Download Selected Proposed Primary schools for {selectedState}</CSVLink>
            
            </>

            
            
          }
        </ExpandableContainer>
      </div>
    </div>
  );
};

export default LayerSelectorItem;
